














































































































































































import CompanySheet from "@/components/company/CompanySheet.vue";
import MNoContent from "@/components/utility/mmmint/MNoContent.vue";
import { ClearanceApprovalTypeEnum } from "@/lib/enum/clearance-approval-type.enum";
import { CurrencyEnum } from "@/lib/enum/currency.enum";
import { RequestStatusEnum } from "@/lib/enum/request-status-enum";
import { IDialog } from "@/lib/interfaces/dialog.interface";
import { formatCurrency } from "@/lib/utility/currency-helper";
import { getAutocompleteFilter } from "@/lib/utility/filter";
import { handleError } from "@/lib/utility/handleError";
import { $t } from "@/lib/utility/t";
import PermissionMixin from "@/mixins/PermissionMixin.vue";
import RulesMixin from "@/mixins/RulesMixin.vue";
import { ClearanceApproval } from "@/models/clearance-approval.entity";
import { Clearance, IClearance } from "@/models/clearance.entity";
import { Company, ICompany } from "@/models/company.entity";
import { ContractBase, IContract } from "@/models/contract.entity";
import { InvoiceLine } from "@/models/invoice-line.entity";
import { Reference } from "@/models/reference.entity";
import { ISharedContent, SharedContent } from "@/models/shared-content.entity";
import { VehicleInsuranceContract, VehicleLeasingContract } from "@/models/vehicle-contract.entity";
import { ResourceEnum } from "@/store/enum/authResourceEnum";
import { UserModule } from "@/store/modules/me-user.store";
import { PartnerModule } from "@/store/modules/partner";
import { mixins } from "vue-class-component";
import { Component, Prop, Watch } from "vue-property-decorator";
import ReportClearanceApprovalContractSelectSheet from "./ReportClearanceApprovalContractSelectSheet.vue";
import { CompanyDataAccessLayer } from "@/store/modules/access-layers/company.access-layer";
import { CompanyServiceEnum } from "@/lib/enum/company-service.enum";

@Component({
  components: {
    ReportClearanceApprovalContractSelectSheet,
    CompanySheet,
    MNoContent
  },
  filters: {}
})
export default class ReportClearanceDialog extends mixins(PermissionMixin, RulesMixin) implements IDialog {
  @Prop({ default: false }) value!: boolean;

  dialog: boolean = this.value;
  readonly getAutocompleteFilter = getAutocompleteFilter;
  readonly formatCurrency = formatCurrency;
  readonly CurrencyEnum = CurrencyEnum;

  isInsuranceApproval = false;
  isLeasingApproval = false;
  isFleetApproval = false;

  workshopEnum = CompanyServiceEnum.WORKSHOP;
  damageBrokerEnum = CompanyServiceEnum.DAMAGE_BROKER;

  requestAt = CompanyServiceEnum.WORKSHOP;

  clearanceApproval = new ClearanceApproval({
    status: RequestStatusEnum.DRAFT,
    type: ClearanceApprovalTypeEnum.WORKSHOP
  });

  clearance: IClearance = new Clearance();

  insuranceContract?: VehicleInsuranceContract | null = null;
  leasingContract?: VehicleLeasingContract | null = null;
  customerContract?: IContract | null = null;

  @Watch("value")
  async onValueChange(val: boolean) {
    if (val) {
      this.reset();

      let insuranceCompanyPromise: Promise<ICompany> | null = null;
      let leasingCompanyPromise: Promise<ICompany> | null = null;

      if (this.activeInsuranceContract) {
        this.insuranceContract = new VehicleInsuranceContract(this.activeInsuranceContract);
        if (this.insuranceContract.companyId) {
          this.insuranceContract.isCompanyEntityLoading = true;
          insuranceCompanyPromise = new Company({
            partnerId: PartnerModule.partner.id,
            id: this.insuranceContract.companyId
          }).fetch();
        }
      }

      if (this.activeLeasingContract) {
        this.leasingContract = new VehicleLeasingContract(this.activeLeasingContract);
        if (this.leasingContract.companyId) {
          this.leasingContract.isCompanyEntityLoading = true;
          leasingCompanyPromise = new Company({
            partnerId: PartnerModule.partner.id,
            id: this.leasingContract.companyId
          }).fetch();
        }
      }

      this.dialog = val;

      if (this.insuranceContract && insuranceCompanyPromise) {
        try {
          this.insuranceContract.company = await insuranceCompanyPromise;
        } finally {
          this.insuranceContract.isCompanyEntityLoading = false;
        }
      }

      if (this.leasingContract && leasingCompanyPromise) {
        try {
          this.leasingContract.company = await leasingCompanyPromise;
        } finally {
          this.leasingContract.isCompanyEntityLoading = false;
        }
      }

      if (this.report.fleetId) {
        await this.report.fetchFleet();
      }

      if (this.report.fleet) {
        await this.report.fleet.fetchContracts();

        if (this.activeCustomerContract) {
          this.customerContract = new ContractBase(this.activeCustomerContract);
          await this.customerContract.fetchCompanyClients();
        }
      }
    }

    if (!val) {
      this.reset();
    }
  }

  @Watch("dialog")
  onDialogChange(val: boolean) {
    this.$emit("input", val);
  }

  requestsLoading = false;

  get partner() {
    return PartnerModule.partner;
  }

  get report() {
    return PartnerModule.report;
  }

  get vehicle() {
    return PartnerModule.report.vehicle;
  }

  get accidentDate() {
    return this.report.accidentDate;
  }

  get activeInsuranceContract() {
    return PartnerModule.report.vehicle?.activeInsuranceContract(this.accidentDate);
  }

  get activeLeasingContract() {
    return PartnerModule.report.vehicle?.activeLeasingContract(this.accidentDate);
  }

  get activeCustomerContract() {
    return this.report?.fleet?.activeCustomerContract(this.accidentDate);
  }

  get fleet() {
    return this.report.fleet;
  }

  get context() {
    return {
      partner: this.partner,
      report: this.report,
      vehicle: this.vehicle
    };
  }

  get validForm() {
    if (this.insuranceContract?.isCompanyEntityLoading || this.leasingContract?.isCompanyEntityLoading) {
      return false;
    }

    return !!this.report.workshopCompanyId || !!this.report.damageBrokerCompanyId;
  }

  get myUserId() {
    return UserModule.userId;
  }

  async create() {
    this.requestsLoading = true;
    try {
      this.clearance.partnerId = this.partner.id;
      this.clearance.assignees = [this.myUserId];
      this.clearance.reportId = this.report.id;
      this.clearance.estimateId = this.lastAcceptedEstimate?.id || undefined;

      const isWorkshop = this.requestAt === CompanyServiceEnum.WORKSHOP;
      const sellerCompanyId = isWorkshop ? this.report.workshopCompanyId : this.report.damageBrokerCompanyId;

      if (!sellerCompanyId) {
        throw new Error(
          isWorkshop
            ? "Workshop company ID is not defined in the report"
            : "Damage broker company ID is not defined in the report"
        );
      }

      if (isWorkshop) {
        if (!this.report.workShopCompany) {
          await this.report.fetchWorkshopEntity();
        }
        if (!this.report.workShopCompany) {
          throw new Error("Error loading workshop entity");
        }
      } else {
        if (!this.report.damageBrokerCompany) {
          await this.report.fetchDamageBrokerEntity();
        }
        if (!this.report.damageBrokerCompany) {
          throw new Error("Error loading damage broker entity");
        }
      }

      const sellerCompany = isWorkshop ? this.report.workShopCompany : this.report.damageBrokerCompany;

      if (!sellerCompany) {
        throw new Error("Seller company entity is not defined");
      }

      this.clearance.seller = sellerCompany.invoiceParty;
      this.clearance.status = RequestStatusEnum.DRAFT;
      this.clearance.refs.push(new Reference({ refId: this.report.id, refType: ResourceEnum.REPORT }));
      if (this.report.vehicleId) {
        this.clearance.refs.push(new Reference({ refId: this.report.vehicleId, refType: ResourceEnum.VEHICLE }));
      }

      const approvals = [
        {
          isActive: this.isInsuranceApproval,
          contract: this.insuranceContract
        },
        {
          isActive: this.isLeasingApproval,
          contract: this.leasingContract
        },
        {
          isActive: this.isFleetApproval,
          contract: this.customerContract
        }
      ];

      for (const { isActive, contract } of approvals) {
        let sharedContent: ISharedContent | null = null;
        if (isActive && contract?.companyId) {
          let clearanceApproval = new ClearanceApproval(this.clearanceApproval).mapFromClearance(this.clearance);
          clearanceApproval.seller = contract.company?.invoiceParty;
          clearanceApproval = await clearanceApproval.create();

          const company = await new Company({
            partnerId: this.partner.id,
            id: contract.companyId
          }).fetch();

          await company.fetchSharedContent(this.report.id);

          if (company.activeSharedContent) {
            await company.activeSharedContent.addRef(
              new Reference({ refId: clearanceApproval.id, refType: ResourceEnum.CLEARANCE_APPROVAL }),
              true
            );

            sharedContent = company.activeSharedContent;
          } else {
            sharedContent = new SharedContent({
              partnerId: this.partner.id,
              title: clearanceApproval.seller?.name,
              description: clearanceApproval.title,
              companyIds: [contract.companyId],
              reportId: this.report.id,
              refs: [
                new Reference({ refId: clearanceApproval.id, refType: ResourceEnum.CLEARANCE_APPROVAL }),
                new Reference({ refId: this.report.id, refType: ResourceEnum.REPORT }),
                ...this.clearance.refs
              ]
            });
            await sharedContent.create();
            company.activeSharedContent = sharedContent;
          }

          CompanyDataAccessLayer.set(company);

          clearanceApproval.sharedContent.push(sharedContent);
          this.clearance.clearanceApprovals.push(clearanceApproval);
          this.clearance.clearanceApprovalIds.push(clearanceApproval.id);
        }
      }

      await this.clearance.create();
      this.report.clearances.unshift(this.clearance);
    } catch (e) {
      handleError(e);
    } finally {
      this.close();
      this.requestsLoading = false;
    }

    return;
  }

  get lastAcceptedEstimate() {
    return this.report.repairEstimates.find(
      estimate => estimate.status === RequestStatusEnum.REPLIED || estimate.status === RequestStatusEnum.ACCEPTED
    );
  }

  open() {
    this.reset();
    this.dialog = true;
  }

  close() {
    this.dialog = false;
    this.reset();
  }

  reset() {
    this.isInsuranceApproval = false;
    this.isLeasingApproval = false;
    this.isFleetApproval = false;
    this.insuranceContract = null;
    this.customerContract = null;
    this.leasingContract = null;

    if (this.report.damageBrokerCompanyId) {
      this.requestAt = CompanyServiceEnum.DAMAGE_BROKER;
    } else {
      this.requestAt = CompanyServiceEnum.WORKSHOP;
    }

    let total = 0;
    if (this.report.repairEstimates.length) {
      const lastAccepted = this.lastAcceptedEstimate;

      if (lastAccepted) {
        total = lastAccepted.totalNet;
        const markupPercent = this.partner?.settings?.clearanceMarkUpInPercent ?? 15; // Default mark up 15 %
        const roundingStep = this.partner?.settings?.clearanceRoundingStep ?? 100; // Default step 100

        /**
         * If an accepted estimate is found, the total amount is increased
         * by the configured percentage and then rounded up to the next
         * multiple of the configured rounding step.
         *
         * Examples:
         *  - markupPercent = 15 → adds 15% to the total
         *  - roundingStep = 100 → rounds up to the next full hundred
         *  - roundingStep = 1 → rounds up to the next full unit (whole number)
         *  - roundingStep = 0.01 → rounds to the nearest cent (effectively no visible rounding)
         */
        total = Math.ceil((total * (1 + markupPercent / 100)) / roundingStep) * roundingStep;
      }
    }

    const li = new InvoiceLine({ title: $t("clearance.defaultPosition"), amount: total });
    this.clearance = new Clearance({ lineItems: [li] });
    this.clearanceApproval = new ClearanceApproval({
      status: RequestStatusEnum.DRAFT,
      type: ClearanceApprovalTypeEnum.WORKSHOP
    });
    this.clearanceApproval.dueFormable = new Date(Date.now() + 7 * 24 * 60 * 60 * 1000).toString();
    if (this.report.claimNumber) {
      this.clearance.title = $t("components.PartnerReportDetail.repair.ReportClearanceDialog.clearanceTitle", {
        title: this.report.title,
        claimNumber: this.report.claimNumber
      });
    }
  }
}
